<template>
  <div class="all-birthday">
    <div class="search" v-show="dataUserList">
      <div class="search-box">
        <i class="search-icon" :class="{'icon-focus': type==='searchList'}"></i>
        <input
          ref="searchInput"
          type="text"
          class="search-input"
          v-model="keyword"
          :class="{'input-focus': type==='searchList'}"
          placeholder="搜索"
          @blur="inputBlur()"
          @focus="inputFocus()"
        />
        <i class="cancel-icon" v-if="type === 'searchList'" @click="clearKeyword()"></i>
        <span class="cancel" v-if="type === 'searchList'" @click="cancelSearch()">取消</span>
      </div>
      <div class="nav" v-if="type!=='searchList' && birthday_dept_serach">
        <div class="breadcrumbs">
          <div v-if="!departmentPath" class="selectDepartmentPathTips">选择部门</div>
          <span
            v-if="departmentPath"
            v-for="item in departmentPath"
            :data-id="item.id"
          >
            <template v-if="dept_origin_data[item.name]">
                <Organization :name="item.name" type="departmentName" :openid="item.name" :useOpenData="dept_origin_data[item.name].useOpenData" ></Organization>
            </template>
            <template v-else>
                {{item.name}}
            </template>
          </span>
          <div class="clear"></div>
        </div>
        <div class="chang-breadcrumbs">
          <a href="javascript:void(0)" @click="showDepartment">切换</a>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <div
      class="loadMore"
      :class="{'loadMoreDisabled':!departmentDisabled,'birthday_dept_serach':!birthday_dept_serach}"
      v-show="type === 'allList' && dataUserList"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="listScrollDisabled"
      infinite-scroll-distance="50"
      ref="searchBox"
    >
      <div class="typeBar">
        <span :class="searchType == 1?'active':''" @click="setType(1)">即将生日</span>
        <span :class="searchType == 2?'active':''" @click="setType(2)">刚过生日</span>
      </div>
      <div class="list-box" v-if="dataUserList && dataUserList.total > 0">
        <div class="birthday-list">
          <ul>
            <li v-for="(item, index) in dataUserList.list" @click="toPersonInfo(item.id)">
              <div class="info">
                <div class="left">
                    <template v-if="item.useOpenData">
                        {{item.real_name | firstName}}
                    </template>
                    <template v-else>
                        {{item.real_name | toSubName}}

                    </template>
                </div>
                <div class="right">
                   <p class="name">
                       <span >
                           <Organization :name="item.real_name" type="userName" :openid="item.member_key_raw" :useOpenData="item.useOpenData" ></Organization>
                       </span>
                   </p>
                  <p class="birthday">
                    <span>{{toDateForYear(item.birthday,'month')}}月{{toDateForYear(item.birthday,'day')}}日</span>
                    <i
                      v-if="item.departments"
                    >
                      <em>|</em>
                       <span class="depa_nowrap">
                            <Organization :name="item.departments" type="departmentName" :openid="item.departments[0]" :useOpenData="item.useOpenData" ></Organization>
                        </span>
                      
                    </i>
                  </p>
                </div>
              </div>
              <div class="action">
                <p>
                  {{toDays(item.nextBirthdayDays)}}
                  <i class="action-icon"></i>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <p class="loading-text" v-show="bottomLoading">加载中...</p>
      </div>
      <div class="no-birthday-list" v-if="!userList || !dataUserList.total">
        <img src="../../assets/img/has-body-icon.png" alt />
        <p v-if="isMember">生日信息还未录入系统</p>
        <p v-if="isMember" class="text">无法送祝福哦</p>
        <p v-if="!isMember" style="color: #000">无法查看同事们的生日</p>
        <p v-if="!isMember" class="text">请联系管理员</p>
      </div>
    </div>

    <div
      class="search-load-more"
      v-show="type === 'searchList'"
      v-infinite-scroll="searchLoadMore"
      infinite-scroll-disabled="searchScrollIsDisabled"
      infinite-scroll-distance="50"
    >
      <div class="search-res">
        <div class="birthday-list">
          <ul>
            <li v-for="(item,index) in searchBirthdayAllList.list" @click="toPersonInfo(item.id)">
              <div class="info">
                <div class="left">
                  <template v-if="item.useOpenData">
                        {{item.userName | firstName}}
                    </template>
                    <template v-else>
                        {{item.userName | toSubName}}
                    </template>
                </div>
                <div class="right">
                    <p class="name" >
                      <span>
                        <Organization :name="item.userName" type="userName" :openid="item.memberKeyRaw" :useOpenData="item.useOpenData" ></Organization>
                      </span>
                   </p>
                  <p class="birthday">
                    {{item.birthday|toDate('month')}}月{{item.birthday|toDate('day')}}日
                     <i
                      v-if="item.departments"
                    >
                      <em>|</em>
                        <span class="depa_nowrap">
                            <Organization :name="item.department" type="departmentName" :openid="item.department[0]" :useOpenData="item.useOpenData" ></Organization>
                        </span>
                    </i>
                  </p>
                </div>
              </div>
              <div class="action">
                <p>
                  {{item.nextBirthdayDays | toDays}}
                  <i class="action-icon"></i>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="coverBox" v-if="isLoading"></div>
    <loading v-if="isLoading"></loading>
    
    <home :ishome="0"></home>
    <Department ref="department" @setDepartmentDisabled="setDepartmentDisabled" @callback="selectDepartment"></Department>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import loading from "../common/loading.vue";
import home from "../common/home.vue";
import Department from "./department";
import Organization from "@/components/common/organization.vue";
export default {
  name: 'birthdaylist',
  data() {
    return {
      departmentPath: null, // 选择的部门
      keyword: "",
      type: "allList", // allList 列表, searchList 搜索
      searchType: 1, // 1 将要过生日的人, 已经过生日的人
      isLoading: false, // false 不显示加载 显示加载效果
      listScrollDisabled: false, //普通列表是否加载的标识
      loadFinish: false, // 是否加载完成
      departmentDisabled: true, // 部门选择控件是否禁用
      dataUserList: {
        // 列表数据
        total: 0,
        totalPage: 0,
        list: []
      },
      params: {
        page: 1,
        size: 20,
        amount: 50,
        before: 0,
        sort: "birthday_md",
        prefixDepartmentIdPath: null
      },
      searchListParams: {
        page: 1,
        size: 20
      },
      _type:'',
        dept_origin_data:{}
    };
  },
  components: {
    loading,
    home,
    Department,
    Organization
  },
  created: function() {
    let _this = this;
    this.$route.query.dept = "";
    this._type = this.$route.query.type || "userName";
  },
  computed: {
    ...mapGetters({
        corpInfo: "corpInfo",
        userLoginFinish: "userLoginFinish",
        userInfo: "userInfo",
        searchBirthdayAllList: "searchBirthdayAllList",
        isMember: "getIsMember",
        userList: "userList",
        searchParams: "searchParams",
        storeLoadFinish: "loadFinish",
        birthdayDataUserList: "birthdayDataUserList",
        curPosY: "curPosY",
        currentCorpId: "currentCorpId",
        corpCustomize:'getCorpCustomize'
    }),
    bottomLoading() {
      return this.dataUserList.list.length > 0 && !this.loadFinish;
    },
    birthday_dept_serach(){
        return this.corpCustomize.birthday_dept_serach&&this.corpCustomize.birthday_dept_serach.value == 1 || false;
    },
  },
  methods: {
    setDepartmentDisabled(departmentDisabled){
      this.departmentDisabled = departmentDisabled;
    },
    selectDepartment(departmentPath) {
        this.departmentPath = null;
        if(departmentPath.list.length > 0) this.departmentPath = departmentPath.list;
        this.dept_origin_data = departmentPath.origin_data;
       
        if(departmentPath.current){
            this.params.prefixDepartmentIdPath = departmentPath.current.treeIdPath
            this.initData()
            this.loadData()
        }
    },
    showDepartment() {
      this.$refs.department.show();
      return false;
    },
    toDays(value) {
      if (this.searchType == 1) {
        if (value < 0) {
          return "生日已过";
        } else if (value === 0) {
          return "今天";
        } else if (value === 1) {
          return "明天";
        } else if (value === 2) {
          return "后天";
        } else {
          return value + "天";
        }
      }
      let isRenYear = this.isRenYear();
      let yearDays = 365;
      if (isRenYear) {
        yearDays = 366;
      }
      return "已过" + (yearDays - value) + "天";
    },
    isRenYear() {
      let year = new Date().getFullYear();
      year += 1;
      return 0 == year % 4 && (year % 100 != 0 || year % 400 == 0);
    },
    clearKeyword() {
      this.keyword = "";
      this.$store.dispatch("initSearchBirthdayList");
      this.$refs.searchInput.focus();
    },
    cancelSearch() {
      this.type = "allList";
      this.keyword = "";
      this.searchListParams.page = 1;
      this.$store.dispatch("initSearchBirthdayList");
    },
    initData() {
      this.params.page = 1;
      this.dataUserList.list = [];
    },
    getUserList(){
        if (this.searchType == 2) {
            this.params.amount = 0;
            this.params.before = this.corpInfo.birthdayBefore || 50;
        } else {
            this.params.amount = this.corpInfo.birthdayAfter || 50;
            this.params.before = 0;
        }
        this.$store.dispatch("setSearchParams", this.params);
        this.$store.dispatch("getUserList", this.params);
    },
    loadData() {
        if(JSON.stringify(this.corpInfo) == '{}'){
            this.$store.dispatch('getCorpInfo').then(()=>{
                this.getUserList()
            });
        }else{
            this.getUserList()
        }
    },
    loadMore() {
      if (this.type != "allList") return;
      if (this.params.page >= this.dataUserList.totalPage) {
        this.loadFinish = true;
        return;
      }
      this.listScrollDisabled = true;
      this.params.page++;
      this.loadData();
    },
    searchLoadMore() {
      if (this.type != "searchList") return;
      if (!this.keyword) return;
      if (this.searchListParams.page >= this.searchBirthdayAllList.totalPage) {
        return;
      }
      this.$store.dispatch("setSearchListScroll");
      let params = {
        data: {
          page: ++this.searchListParams.page,
          pageSize: this.searchListParams.size,
          keyword: this.keyword
        },
        type: "scroll"
      };
      this.$store.dispatch("doSearchBirthdayAllList", params);
    },
    inputBlur() {},
    inputFocus() {
      this.type = "searchList";
      if (this.searchType == 2) {
        this.setType(1);
        this.params.page = 1;
      }
    },
    toPersonInfo(id) {
      this.$store.dispatch("setCurPosY", {
        value: this.$refs.searchBox.scrollTop
      });
      this.$router.push({
        name: "birthdayPersonal",
        query: {
          subUid: id,
          corpId: this.currentCorpId
        }
      });
    },
    setType(searchType) {
      this.searchType = searchType
      this.initData()
      this.loadData()
    },
    toDateForYear(value, type) {
      let arr = value.split("-");
      if (type === "month") {
        return arr[1];
      } else if (type === "day") {
        return arr[2];
      }
    }
  },
  mounted() {
    if (this.curPosY && this.curPosY.value > 0) {
      this.isLoading = true;
      this.$nextTick(() => {
        this.$refs.searchBox.scrollTo(0, this.curPosY.value);
        this.$store.dispatch("setCurPosY", { value: 0 });
        this.isLoading = false;
      });
    }
    this.searchType = this.$route.query.type || 1;
    if (this.searchParams && JSON.stringify(this.searchParams)!='{}') {
      let searchParams = $.extend(true, {}, this.searchParams);
      this.params = searchParams;
      let dataUserList = $.extend(true, {}, this.birthdayDataUserList);
      this.dataUserList = dataUserList;
      let storeLoadFinish = $.extend(true, {}, this.storeLoadFinish);
      this.loadFinish = storeLoadFinish.value;
    } else {
      this.loadData();
    }
  },
  watch: {
    keyword: {
      handler: function() {
        if (!this.keyword) {
          this.$store.dispatch("initSearchBirthdayList");
          return;
        }
        this.searchListParams.page = 1;
        this.$store.dispatch("initSearchBirthdayList");
        let params = {
          data: {
            page: 1,
            pageSize: 20,
            keyword: this.keyword
          },
          type: "normal"
        };
        this.$store.dispatch("doSearchBirthdayAllList", params);
      },
      deep: true
    },
    userList: {
      handler: function() {
        this.listScrollDisabled = false;
        // this.dataUserList.list = [];
        this.dataUserList.total = this.userList.total;
        this.dataUserList.totalPage = this.userList.totalPage;

        if (this.userList.list == null || this.userList.list.length == 0) {
          this.listScrollDisabled = true;
          this.loadFinish = true;
        } else {
        //    this.dataUserList.list = $.extend(true, this.userList.list, this.dataUserList.list)
          this.dataUserList.list = this.dataUserList.list.concat(
            this.userList.list
          );
          // 如果加载的数据数量小于size就加载跨年数据
          if (this.userList.total < this.params.size) {
            this.params.page++;
            this.loadData();
          }
        }
        this.$store.dispatch("setLoadFinish", { value: this.loadFinish });
        this.$store.dispatch("setBirthdayDataUserList", this.dataUserList);
      },
      deep: true
    },
    $route(to, from) {
        if(to.name=='birthdayList' && from.name=='care') {
            this.departmentPath = null
            this.searchType = 1
            this.params= {
            page: 1,
            size: 20,
            amount: 50,
            before: 0,
            sort: "birthday_md",
            prefixDepartmentIdPath: null
            }
            this.type= "allList"
            this.keyword = "";
            this.dataUserList= {
            // 列表数据
            total: 0,
            totalPage: 0,
            list: []
            };
            this.loadData()
        }
    },
  },
};
</script>

<style lang="scss" scoped>
.depa_nowrap{
    width: 2.9rem;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.loadMore{
  &.loadMoreDisabled{
    overflow: hidden;
  }
}
.all-birthday .no-birthday-list {
  height: 80%;
}
</style>